import { render } from "./BlockUI.vue?vue&type=template&id=9de9e9ee&scoped=true"
import script from "./BlockUI.vue?vue&type=script&lang=js"
export * from "./BlockUI.vue?vue&type=script&lang=js"

import "./BlockUI.vue?vue&type=style&index=0&id=9de9e9ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de9e9ee"]])

export default __exports__